import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { takeUntil, tap } from 'rxjs/operators';
import { DestroyableComponent } from '../../core/utils/destroyable.component';

import { LoadingService } from '../../providers/loading/loading.service';
import { OrderService } from '../../providers/order/order.service';

interface DialogData {
  id: number;
  price: number;
}

@Component({
  selector: 'app-new-price',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule],
  templateUrl: './new-price.component.html',
  styleUrls: ['./new-price.component.scss'],
})
export class NewDiscountComponent extends DestroyableComponent implements OnInit {
  public message: string;
  public dataForm = this.buildDataForm();
  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private loadingService: LoadingService,
    public dialogRef: MatDialogRef<NewDiscountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    super();
  }

  price: number;
  discount: number = 0;

  ngOnInit() {
    this.price = this.data.price;
    this.getControl('discount').valueChanges.pipe(
      takeUntil(this.onDestroy),
      tap(discount => this.getControl('priceWithDiscount')
        .setValue(+this.getPriceWithDiscount(discount), { emitEvent: false }))
    ).subscribe();

    this.getControl('priceWithDiscount').valueChanges.pipe(
      takeUntil(this.onDestroy),
      tap(priceWithDiscount => this.getControl('discount')
        .setValue(+this.getDiscountByNewPrice(priceWithDiscount), { emitEvent: false }))
    ).subscribe();
  }

  public getPriceWithDiscount(discount) {
    return this.orderService.formatPrice(this.price - this.price * (discount / 100));
  }

  public getDiscountByNewPrice(newPrice) {
    return this.orderService.formatPrice((1 - newPrice / this.price) * 100);
  }

  public getControl(key: string) {
    return this.dataForm.controls[key];
  }

  public sendNewDiscount() {
    this.loadingService.startLoading();
    const payload = this.dataForm.getRawValue();
    this.orderService.offerrDiscount({
      id: payload.id,
      discount: payload.discount,
    })
      .subscribe(
        (res) => {
          this.dialogRef.close(res);
          this.loadingService.stopLoading();
        },
        () => {
          this.loadingService.stopLoading();
          this.dialogRef.close();
        });
  }

  private buildDataForm() {
    return this.fb.group({
      id: new FormControl(this.data.id, [Validators.required]),
      discount: new FormControl(0, [Validators.required]),
      priceWithDiscount: new FormControl(this.orderService.formatPrice(this.data.price), [Validators.required]),
    });
  }
}
